import {processMutation, processQuery, genericMutations, deepValue} from '../utils'
import TICKET_LIST from '../../graphql/ticket/list.graphql'
import TICKET_UPLOAD from '../../graphql/ticket/upload.graphql'
import TICKET_CREATE from '../../graphql/ticket/create.graphql'
import TICKET_UPDATE from '../../graphql/ticket/update.graphql'
import TICKET_DELETE from '../../graphql/ticket/delete.graphql'
import TICKET_DELETE_MULTI from '../../graphql/ticket/deleteMulti.graphql'

export default {
    namespaced: true,
    state: {
        list: [],
        detail: null,
        loading: false,
        paging: {
            page: 1
        },
    },

    mutations: {
        ...genericMutations('list', 'detail', 'paging'),

        startLoading(state) {
            state.loading = true
        },
        stopLoading(state) {
            state.loading = false
        },
    },

    actions: {
        async list({commit}, filter) {
            commit('startLoading')
            try {
                const result = await this.$apollo.query({
                    query: TICKET_LIST,
                    fetchPolicy: 'no-cache',
                    variables: filter
                })
                const data = result.data.admin.ticket.list
                const res = data.edges.map(row => row.node)
                commit('setList', res)
                commit('setPaging', {
                    page: filter.page,
                    hasNextPage: data.pageInfo.hasNextPage,
                    hasPreviousPage: data.pageInfo.hasNextPage,
                    endCursor: data.pageInfo.endCursor,
                    startCursor: data.pageInfo.startCursor,
                    totalCount: data.totalCount
                })
                commit('stopLoading')

            } catch(error) {
                commit('stopLoading')
                if (error.graphQLErrors.length) {
                    this.commit('setStoreErrorMessage', error.graphQLErrors[0].message)
                } else {
                    this.commit('setStoreErrorMessage', error.message)
                }
            }
        },

        async upload({commit}, data) {
            return await processMutation(this, TICKET_UPLOAD, 'ticket.upload', data)
        },

        async create({commit}, data) {
            // if (data.blockId) {
            //     data.blockId = parseInt(data.blockId)
            // }
            return await processMutation(this, TICKET_CREATE, 'ticket.create', data)
        },

        async update({commit}, data) {
            return await processMutation(this, TICKET_UPDATE, 'ticket.update', data)
        },

        async delete({commit}, id) {
            return await processMutation(this, TICKET_DELETE, 'ticket.delete', {id: id})
        },

        async deleteMulti({commit}, id) {
            return await processMutation(this, TICKET_DELETE_MULTI, 'ticket.deleteMulti', {ids: id})
        },
    }
}
